import { render, staticRenderFns } from "./CargoAiHost.vue?vue&type=template&id=5843b4be&scoped=true&"
import script from "./CargoAiHost.vue?vue&type=script&lang=js&"
export * from "./CargoAiHost.vue?vue&type=script&lang=js&"
import style0 from "./CargoAiHost.vue?vue&type=style&index=0&id=5843b4be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5843b4be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5843b4be')) {
      api.createRecord('5843b4be', component.options)
    } else {
      api.reload('5843b4be', component.options)
    }
    module.hot.accept("./CargoAiHost.vue?vue&type=template&id=5843b4be&scoped=true&", function () {
      api.rerender('5843b4be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CargoAi/CargoAiHost.vue"
export default component.exports